import api from "../utils/api";
import { isGuid } from "../utils/string";
import { LOGOUT } from "./types";
import { pack } from "./alert";
import { JavaScripttoXML } from "../utils/serialize";
import { applyCustomValues } from "../utils/template-custom-fields";

export const get = (uuid=null) => async (dispatch) => {
    try {
        const res = await api.get(`/email/templates/${isGuid(uuid) ? uuid : ""}`);
        return res.data?.items ?? res.data ?? [];
    } catch (err) {
        if (err?.response?.status === 401) {
            dispatch({
                type: LOGOUT
            });
        } else {
            dispatch(pack(["email template failed to load"], "error"));
        }
        return [];
    }
}

export const flagged = ({ flags }) => async (dispatch) => {
    try {
        const res = await api.get(`/email/templates/f/${flags}`);
        return res.data?.items ?? [];
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return [];
    }
}

export const global = () => async (dispatch) => {
    try {
        const res = await api.get("/email/templates/g");
        return res.data?.items ?? [];
    } catch (err) {
        console.log(err);
        return [];
    }
}

export const register = ({ parentUuid, name, caption, flags, hidden, configuration }) => async (dispatch) => {
    try {
        const res = await api.post("/email/templates/r", {
            parentUuid,
            name,
            caption,
            flags,
            hidden,
            configuration
        });
        dispatch(pack(["email template imported"], "success"));
        return res.data ?? {};
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        else dispatch(pack(["email template import failed"], "error"));
        return {};
    }
}

export const save = ({uuid, name, caption, category, from, replyTo, subject, html, criteria, configuration, flags, hidden}) => async (dispatch) => {
    try {
        const resolvedConfiguration = configuration || { criteria };
        const res = await api.post(`/email/templates`, { uuid, name, caption, category, from, replyTo, subject, html, configuration: resolvedConfiguration, flags, hidden });
        dispatch(pack(["email template saved"], "success"));
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const destroy = (uuid) => async (dispatch) => {
    try {
        const res = await api.delete(`/email/templates/${uuid}`);
        dispatch(pack(["email template deleted"], "success"));
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        else dispatch(pack(["email template delete failed"], "error"));
    }
}

export const send = ({name, configuration, json, custom, xml, recipient, to, cc, bcc, from, display, subject, body, attachments}) => async (dispatch) => {
    try {
        if (json && custom) json = applyCustomValues(json, custom);
        if (json && !xml) xml = JavaScripttoXML(json); 
        const res = await api.post(`/email/send`, {
            name,
            configuration,
            xml,
            json,
            custom,
            recipient,
            to,
            cc,
            bcc,
            from,
            display,
            subject,
            body,
            attachments
        });
        dispatch(pack(["email sent"], "success"));
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        else dispatch(pack(["email failed to send"], "error"));
        throw err;
    }
}

export const suggest = ({ body, rules, subject, to, cc, bcc }) => async (dispatch) => {
    try {
        const res = await api.post(`/email/suggest`, { body, rules, subject, to, cc, bcc });
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        else {
            const message =
                err?.response?.data?.error?.message ||
                err?.response?.data?.message ||
                err?.message ||
                "email suggestion failed";
            dispatch(pack([message], "error"));
        }
        throw err;
    }
}
